/**
 * Головний компонент додатку Salon Booking System
 * Налаштовує всі глобальні провайдери
 * @component App
 * @file App.tsx
 * @path frontend/src/App.tsx
 */

import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { LanguageProvider } from './contexts/LanguageContext';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LocationProvider } from './contexts/LocationContext';
import { NotificationProvider, useNotification } from './contexts/NotificationContext';
import NotificationSnackbar from './components/NotificationSnackbar/NotificationSnackbar';
import CanonicalTag from './components/CanonicalTag/CanonicalTag';
import GoogleAnalytics from './components/GoogleAnalytics';
import CookieConsent from './components/CookieConsent';
import AppRoutes from './routes/AppRoutes';
import './App.css';

const AppContent: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <>
      <GoogleAnalytics 
        measurementId="G-4F2VRZPPR1" 
        consentMode="default"
        debugMode={false}
      />
      <CanonicalTag />
      <AppRoutes />
      <NotificationSnackbar
        notifications={notifications}
        onClose={removeNotification}
      />
      <CookieConsent />
    </>
  );
};

const App: React.FC = () => {
  return (
      <LanguageProvider>
        <AuthProvider>
          <ThemeProvider>
            <LocationProvider>
              <NotificationProvider>
                <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                  <AppContent />
                </Router>
              </NotificationProvider>
            </LocationProvider>
          </ThemeProvider>
        </AuthProvider>
      </LanguageProvider>
  );
};

export default App;
